import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=2a9c37a6&scoped=true&"
import script from "./Informacion.vue?vue&type=script&lang=ts&"
export * from "./Informacion.vue?vue&type=script&lang=ts&"
import style0 from "./Informacion.vue?vue&type=style&index=0&id=2a9c37a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c37a6",
  null
  
)

export default component.exports